import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { phoneQueryKeys } from './queryKeys';

const getServiceCompanies = async () => {
  return await request.get(
    `/Phone/service_companies`,
    {},
    'При загрузке списка управляющих компаний произошла ошибка'
  );
};

const useServiceCompanies = (options) =>
  useQuery(phoneQueryKeys.serviceCompanies(), getServiceCompanies, options);

export default useServiceCompanies;
